import { httpInterceptor } from '../http-interceptor';

export class LocationService {
  static ENDPOINTS = {
    GET_ALL: 'Location/getalllocations',
    SAVE_LOCATION: 'Location/savelocation'
  };

  static async getAllLocations(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

  static async saveLocation(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_LOCATION, data);
  }

  static async printLocations(data) {
    return httpInterceptor.post('Location/printlocations', data);
  }
}
